// extracted by mini-css-extract-plugin
module.exports = {"root":"FloatingLinkEditor_root___kIQq","inner":"FloatingLinkEditor_inner__uXsg_","form":"FloatingLinkEditor_form___Tzz9"};